import MainContent from '../../components/mainContent/MainContent';
import { LiquidacionFinalContent } from './components/LiquidacionFinalContent';

export default function LiquidacionFinal() {
    return (
        <MainContent
            component={<LiquidacionFinalContent />}
            titulo='Liquidación Final'
            titleCondensed
        />
    );

};
